import { render, staticRenderFns } from "./exhibitorsPC.vue?vue&type=template&id=d6f2663a&scoped=true"
import script from "./exhibitorsPC.vue?vue&type=script&lang=js"
export * from "./exhibitorsPC.vue?vue&type=script&lang=js"
import style0 from "./exhibitorsPC.vue?vue&type=style&index=0&id=d6f2663a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f2663a",
  null
  
)

export default component.exports